import React from 'react'
import './cta.css'

function Cta() {
  return (
    <div className='gpt3__cta'>
      <div className='gpt3__cta-content'>
      <p>Solicite acceso anticipado para comenzar</p>
      <h3>Regístrese hoy y comience a explorar las infinitas posibilidades.</h3>
      </div>
      <div className='gpt3__cta-btn'>
        <button type='button'>Empezar</button>

      </div>
    </div>
  )
}

export default Cta